import i18n from "i18next";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { SendRegular } from "@fluentui/react-icons";

interface IRequestAQuoteDialogProps {
  isDialogOpen: boolean;
  onDismiss: any;
  onQuoteRequested: any;
  items: any;
}

function RequestAQuoteDialog(props: IRequestAQuoteDialogProps) {
  const requestAQuote = () => {
    const items: any[] = [];
    props.items.forEach((item: any) => {
      items.push(item.userBedarfGuid);
    });
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/userbedarfe/GetAQuote`, items)
      .then((data: any) => {
        props.onQuoteRequested();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Dialog open={props.isDialogOpen}>
      <DialogSurface>
        <DialogTitle>{i18n.t<string>("anfragen")}</DialogTitle>
        <DialogBody>
          <DialogContent>
            {props.items.length > 1
              ? i18n
                  .t<string>("anfragenSubText")
                  .replace("{0}", props.items.length)
              : i18n.t<string>("anfragenSubTextSingle")}
          </DialogContent>
          <DialogActions>
            <Button
              icon={<SendRegular />}
              appearance="primary"
              onClick={() => {
                requestAQuote();
              }}
            >
              {i18n.t<string>("anfragen")}
            </Button>
            <Button
              onClick={() => {
                props.onDismiss();
              }}
            >
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default RequestAQuoteDialog;
